import { createContext, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { selectUser } from '../reducers/UserReducer'
import { getInternshipStudentEvaluations } from '../utils/api/evaluationInternship'
import { getEvaluationQuestions } from '../utils/api/evaluation'
import { getStudentInternships } from '../utils/api/student'
import { OtherRoles } from '../utils/constants'

export const EvaluationsContext = createContext()

const EvaluationsProvider = ({ children }) => {
  const user = useSelector(selectUser)

  const [questions, setQuestions] = useState({})
  const [evaluations, setEvaluations] = useState({})
  const [internshipsToEvaluate, setInternshipsToEvaluate] = useState([])

  useEffect(() => {
    if (user.id && user.roles.includes(OtherRoles.STUDENT)) {
      getStudentInternships(user, user.student, { studentEvaluated: false, contexts: ['sector', 'institution'] }).then(json => {
        if (json?.data) {
          setInternshipsToEvaluate(json.data)
        }
      })
    }
  }, [user.id])

  const getQuestions = institution => {
    if (questions[institution.id]) {
      return new Promise(resolve => {
        resolve(questions[institution.id])
      })
    }

    return getEvaluationQuestions(user, institution)
      .then(json => {
        const newQuestions = { ...questions }
        newQuestions[institution.id] = json.data

        setQuestions(newQuestions)

        return json?.data ?? []
      })
  }

  const getEvaluations = internship => {
    if (evaluations[internship.id]) {
      return new Promise(resolve => {
        resolve(evaluations[internship.id])
      })
    }

    return getInternshipStudentEvaluations(user, internship).then(json => {
      const newEvaluations = { ...evaluations }

      newEvaluations[internship.id] = json.data

      setEvaluations(newEvaluations)

      return json?.data ?? []
    })
  }

  const deleteEvaluations = (internship) => {
    const newEvaluations = { ...evaluations }

    delete newEvaluations[internship.id]

    setEvaluations(newEvaluations)
  }

  return (
    <EvaluationsContext.Provider
      value={{ getQuestions, getEvaluations, deleteEvaluations, internshipsToEvaluate, setInternshipsToEvaluate }}
    >
      {children}
    </EvaluationsContext.Provider>
  )
}

export default EvaluationsProvider
